// extracted by mini-css-extract-plugin
module.exports = {"Valentines":"Valentines_Valentines__2GZSu","frame":"Valentines_frame__3yghK","container":"Valentines_container__2qu1L"};